module.exports = __webpack_public_path__ + "img/z2.27c158a1.png";